enum EcrWorkflowTask {
  INTRODUCTION = 'INTRODUCTION',
  PROPOSE_RECIPIENTS = 'PROPOSE_RECIPIENTS',
  IDENTITY_VERIFICATION = 'IDENTITY_VERIFICATION',
  SCHEDULE_ISSUANCE_CEREMONY = 'SCHEDULE_ISSUANCE_CEREMONY',
  ISSUANCE_CEREMONY = 'ISSUANCE_CEREMONY'
}

export default EcrWorkflowTask
